import Popover from "@material-ui/core/Popover";
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import { ReactComponent as InviteSvgComponent } from "assets/icons/invite.svg";
import { ReactComponent as MergeIcon } from "assets/icons/MergeAccountIcon.svg";
import { ReactComponent as ReversalSvg } from "assets/icons/reversal.svg";
import DeActive from "assets/icons/svg/deActive";
import React from "react";
import { ReactComponent as AddUserSvg } from "../assets/icons/add-user.svg";
import ActionSvgComponent from "../assets/icons/svg/actionSvg";
import DeleteSvgComponent from "../assets/icons/svg/DeleteSvg/Delete";
import EditSvgComponent from "../assets/icons/svg/Edit/index";
import EyeSvgComponent from "../assets/icons/svg/EyeSvg/Eye";
import DeleteSvgComponentTemplete from "../assets/icons/Unbatch.svg";
import "./style.scss";
export default function PopOver({
  onEditClick,
  templateVal = false,
  onDeleteClick,
  onMergeClick,
  checkActive,
  onActiveClick,
  onReversalClick,
  onViewClick,
  style,
  onEditNoteClick,
  onInviteClick,
  inviteText,
  onAddMournerClick,
  onDisableMemberUserClick,
  disableMemberUserText,
  popOverWidth = 150,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <ActionSvgComponent
        height={style ? style.height : 14}
        width={style ? style.width : 14}
        onClick={handleClick}
        color={style && style.color}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: `${templateVal ? "left" : "center"}`,
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        className={templateVal ? "template__action" : ""}
      >
        <div
          className={`${templateVal} ? action-pop-over template : action-pop-over`}
          style={{
            width: `${popOverWidth}px`,
          }}
        >
           {onInviteClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onInviteClick();
                handleClose();
              }}
            >
              <InviteSvgComponent
                className="svg-size" 
                style={{
                  marginRight: "1px",
                }}
              /> {inviteText}
            </div>
          ) : (
            ""
          )}
          {onDisableMemberUserClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onDisableMemberUserClick();
                handleClose();
              }}
            >
              <DoDisturbOnIcon
                style={{
                  fill: "#2555ef",
                  width: "18px",
                  height: "18px",
                  marginRight: "7px",
                }}
              />
              {disableMemberUserText}
            </div>
          ) : (
            ""
          )}
          {onAddMournerClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onAddMournerClick();
                handleClose();
              }}
            >
              <AddUserSvg className="svg-size add-mourner-svg" width={16} height={16} />Add Mourner
            </div>
          ) : (
            ""
          )}
          {onViewClick && templateVal ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onViewClick();
                handleClose();
              }}
            >
              <EyeSvgComponent className="svg-size" /> View
            </div>
          ) : (
            ""
          )}
          {onEditClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onEditClick();
                handleClose();
              }}
            >
              {templateVal ? (
                <EditSvgComponent className="svg-size" />
              ) : (
                <EyeSvgComponent className="svg-size" />
              )}
              {templateVal ? "Edit" : "View"}
            </div>
          ) : (
            ""
          )}
          {/* {onViewClick && templateVal && (
            <>
              <div className="billing-action-pop-over eye">
                <div className="finance-pop-over" onClick={onViewClick}>
                  <EyeSvgComponent className="mr-6" /> View
                </div>
              </div>

              <div className="billing-action-pop-over">
                <div
                  className="finance-pop-over"
                  onClick={() => {
                    onEditClick();
                    handleClose();
                  }}
                >
                  <EditSvgComponent className="mr-6" /> Edit
                </div>
              </div>
            </>
          )} */}
          {onReversalClick ? (
            <div
              className="reversal-pop-over"
              onClick={() => {
                onReversalClick();
                handleClose();
              }}
            >
              <ReversalSvg className="svg-size" width={40} height={40} />{" "}
              Reversal
            </div>
          ) : (
            ""
          )}
          {/* {onActiveClick ? (
            <div
              className="center-pop-over"
              onClick={() => {
                onActiveClick();
                handleClose();
              }}
            >
              <DeActive className="svg-size" />
              {!checkActive ? 'Activate' : ' Deactivate'}
            </div>
          ) : (
            ''
          )} */}
         
          {onEditNoteClick ? (
            <div
              className="edit-pop-over"
              onClick={() => {
                onEditNoteClick();
                handleClose();
              }}
            >
              <EditSvgComponent className="svg-size" /> Edit
            </div>
          ) : (
            ""
          )}

          {onDeleteClick ? (
            <div
              className="delete-pop-over"
              onClick={() => {
                onDeleteClick();
                handleClose();
              }}
            >
              {templateVal ? (
                <img
                  src={DeleteSvgComponentTemplete}
                  alt="deleteIcon"
                  className="svg-size"
                  style={{
                    width: "20px",
                    height: "20px",
                  }}
                />
              ) : (
                <DeleteSvgComponent className="svg-size" />
              )}
              Delete
            </div>
          ) : (
            ""
          )}
          {onMergeClick ? (
            <div
              className="merge-pop-over"
              onClick={() => {
                onMergeClick();
                handleClose();
              }}
            >
              < MergeIcon className="svg-size" />
              Merge
            </div>
          ) : (
            ""
          )}
        </div>
      </Popover>
    </div>
  );
}
